import { render, staticRenderFns } from "./BasketToolbar.vue?vue&type=template&id=5153123b&scoped=true&"
import script from "./BasketToolbar.vue?vue&type=script&lang=js&"
export * from "./BasketToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BasketToolbar.vue?vue&type=style&index=0&id=5153123b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153123b",
  null
  
)

export default component.exports